import { UpdateKeyValueRequest } from "@models/base/updateKeyValueRequest.model";

export class UpdateCalendarioJudicialRequest extends UpdateKeyValueRequest{
  fecha?: Date;
  esHabil!: boolean;
  esFeriado!: boolean;
  esFeriaJudicial!: boolean;
  motivo!: string;
  idJurisdiccion?: number;
  idFuero?: number;
  idJuzgado?: number;
  horarioDesde?: string; // Formato recomendado: "HH:mm"
  horarioHasta?: string;
}
